export const PIXI_TRIALIST_PREFERENCES_KEYS = {
  COMPLETED_DESIGN_SCREEN_CONTENT: "completed_design_screen_content",
  COMPLETED_PAIR_SCREEN: "completed_pair_screen",
  COMPLETED_SET_CONTENT: "completed_set_content",
  LAUNCHED_VIRTUAL_SCREEN: "launched_virtual_screen",
};
